import Image from "next/image";

interface Props {
	title: string;
	content: string;
	imageUrl: string;
	icon: JSX.Element;
}

export default function ProdCard(props: Props) {
	return (
		<div className="mb-8">
			<div className="px-4.5 text-white">
				<div className="flex items-center text-xl font-semibold">
					<span className="mr-1">{props.title}</span>
					<div className="w-8 h-8 flex items-center justify-center">{props.icon}</div>
				</div>
				<div className="mt-1.5 text-sm font-normal">{props.content}</div>
			</div>

			<div className="text-center">
				<Image src={props.imageUrl} alt="adv" width={375} height={250} loading="lazy" />
			</div>
		</div>
	);
}
